import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Option } from '../select-field/select-field.component';

@Component({
  selector: 'app-multiple-select-field',
  templateUrl: './multiple-select-field.component.html'
})
export class MultipleSelectFieldComponent {
  @Input() label!: string;
  @Input() options!: Option[];
  @Input() form!: FormControl;
  @Input() placeholder: string = '選択して下さい';
  @Input() allLabel: string = '全て';
  @Input() indeterminateLabel: string = '件選択';
  @Output() formChange = new EventEmitter<FormControl>();

  onChange(): void {
    this.formChange.emit(this.form);
  }

  isRequired(): boolean {
    return this.form.hasValidator(Validators.required);
  }

  isIndeterminate(): boolean {
    const selected = this.form.value;
    return selected
      ? selected.length > 0 && selected.length < this.options.length
      : false;
  }

  isChecked(): boolean {
    const selected = this.form.value;
    return selected ? selected.length === this.options.length : false;
  }

  toggleSelection(event: MatCheckboxChange): void {
    if (event.checked) {
      const values = this.options.map((option) => option.value);
      this.form.setValue(values);
    } else {
      this.form.setValue([]);
    }
    this.formChange.emit(this.form);
  }

  triggerText(): string {
    if (this.isChecked()) {
      return this.allLabel;
    } else if (this.isIndeterminate()) {
      const list = this.form.value;
      if (list.length === 1) {
        const option = this.options.find((item) => item.value === list[0]);
        return option?.name ?? '';
      }
      return `${list.length}${this.indeterminateLabel}`;
    } else {
      return '';
    }
  }
}
